<template>
  <div>
    <authCheck :pageUser="pageUser" :pageDevice="pageDevice" :did="did" :pageBindFinished="pageBindFinished">

      <div class="pageUserIcon" v-if="!presentationMode && pageUser && pageUser.photoURL">
        <b-img :src="pageUser.photoURL" @click="showPageUser" :alt="`${pageUser.displayName}의 사진`" v-b-tooltip :title="`${pageUser.displayName}의 정보 보기`" class="cursor-pointer"/>
      </div>

      <h1 class="documentTitle" v-if="pageUser && pageDevice && !presentationMode" v-touch:touchhold="togglePresentationMode" v-touch:swipe="swipeApp">
        <b-button @click="showPageUser" v-b-tooltip :title="(isLoginUserPageUser)?'나의 정보 보기':`${pageUser.displayName}의 정보 보기`" variant="secondary" size="lg" class="fontSize1Dot4 p-0 pl-1 pr-1 mr-1 displayNoneMax630">
          {{(isLoginUserPageUser)? '나': pageUser.displayName}}</b-button><small class="fontSize1Dot4 displayNoneMax630">의</small>

        <router-link :to="{ name: 'tinkDevice', params: { uid: did, mode: 'intro' }}" class="fontSize1Dot6 narrowText" custom v-slot="{ navigate }">
          <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
            {{pageDevice.name}}
          </span>  
        </router-link>

        <b-button
        v-if="pageDevice" :variant="(pageBinded)? 'primary': 'secondary'" size="sm" class="ml-1 mr-1 fontSizeDot8 pt-dot1 pb-dot1 pr-2 pl-2 narrowText2 borderRadiusDot75" :disabled ="toggleRealtimeDisabled" @click="toggleRealtimeChanged" v-b-tooltip.hover title="내 기기나 내가 관리하는 기기가 아니거나 개인 설정에서 기기 실시간 연결이 꺼져있으면 일정 시간이 지나면 실시간이 꺼집니다.">
          <span class="displayNoneMax589">실시간</span>
          <span v-if="pageBinded">켜짐</span>
          <span v-else>꺼짐</span>
        </b-button>

        <b-button v-if="pageDevice" :variant="(pageDevice.active)? 'danger': 'secondary'" size="sm" class="ml-1 mr-1 fontSizeDot8 pt-dot1 pb-dot1 pr-2 pl-2 narrowText2 borderRadiusDot75" :disabled ="togglePageDeviceActiveDisabled || !isLoginUserPageUser&&!isLoginUserAdmin&&!isLoginUserPageDeviceOAdmin" @click="toggleActiveChanged"
        v-b-tooltip.hover title="기기 꺼짐이면 IOT 기기에서
        데이터를 보내더라도 저장되지 않습니다.">
          <span class="displayNoneMax589">업로드</span>
          <span v-if="pageDevice.active">켜짐</span>
          <span v-else>꺼짐</span>
        </b-button>
      </h1>

      <div v-if="!presentationMode && pageUser && pageDevice" class="pl-3 pt-1 pb-1 pr-1 bg-light gothic fontSizeDot9 border-top border-bottom controlRow" v-touch:touchhold="togglePresentationMode" v-touch:swipe="swipeApp">
        <div class="leftControl mt-1">
          <span class="fontSizeDot7 font-weight-bold text-secondary">&lsaquo;</span>
          <router-link :to="{ name: 'tinkUser', params: { uid: pageUser.id } }" custom v-slot="{ navigate }">
            <span @click="navigate" @keypress.enter="navigate" class="cursor-pointer" role="link">
              {{(isLoginUserPageUser)? '내': pageUser.displayName + '의'}} 기기목록
            </span>  
          </router-link>
        </div>
        <div class="pl-1 pt-1 pb-1 pr-3 rightExpandControl">
          <span v-for="sensor, id in pageDevice.sensors" :key="id">
            <router-link v-if="sensor.id" :to="{ name: 'tinkSensor', params: { sid: sensor.id }}" custom v-slot="{ navigate }">
              <b-button size="sm" variant="secondary" @click="navigate" @keypress.enter="navigate" role="link" class="btn pl-1 pr-1 pt-0 pb-0 ml-1 mr-1 mt-dot1 mb-dot1 fontSizeDot8 cursor-pointer" v-b-tooltip.hover :title="sensor.title">
                {{ sensor.title }}
              </b-button>
            </router-link>
          </span>
          <span class="fontSizeDot7 font-weight-bold text-secondary">&rsaquo;</span>
        </div>
      </div>

      <div v-if="pageUser != null && pageDevice != null" class="ml-3 mr-3 mb-3 mt-2">
        <deviceReport v-if="mode == 'report'" :pageBinded="pageBinded" :pageUser="pageUser" :pageDevice="pageDevice"/>
        <deviceLog v-else-if="mode == 'log'" :pageBinded="pageBinded" :pageUser="pageUser" :pageDevice="pageDevice"/>
        <deviceAttributes v-else-if="mode == 'attributes'" :pageBinded="pageBinded" :pageUser="pageUser" :pageDevice="pageDevice"/>
        <deviceTest v-else-if="mode == 'upload'" :pageBinded="pageBinded" :pageUser="pageUser" :pageDevice="pageDevice"/>
        <deviceAuth v-else-if="mode == 'auth'" :pageBinded="pageBinded" :pageUser="pageUser" :pageDevice="pageDevice" :serial="serial"/>
        <deviceSerial v-else-if="mode == 'serial'" :pageBinded="pageBinded" :pageUser="pageUser" :pageDevice="pageDevice" :action="action" :serial="serial"/>
        <deviceSensors v-else-if="mode == 'sensors'" :pageBinded="pageBinded" :pageUser="pageUser" :pageDevice="pageDevice" :action="action"/>
        <deviceConfig v-else-if="mode == 'config'" :pageBinded="pageBinded" :pageUser="pageUser" :pageDevice="pageDevice"/>
        <deviceIntro v-else  :pageBinded="pageBinded" :pageUser="pageUser" :pageDevice="pageDevice"/>
        <tPageUser :pageUser="pageUser" :pageDevice="pageDevice"/>
      </div>

    </authCheck>
  </div>
</template>
<script>

import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import { db } from "@/plugins/firebase.js"

import uiUtil from "@/mixins/util.js"
import user from "@/mixins/user.js"

import authCheck from "@/components/authCheck.vue"

import deviceIntro from "@/components/device/deviceIntro.vue"
import deviceConfig from "@/components/device/deviceConfig.vue"
import deviceAuth from "@/components/device/deviceAuth.vue"
import deviceSensors from "@/components/device/deviceSensors.vue"
import deviceSerial from "@/components/device/deviceSerial.vue"
import deviceTest from "@/components/device/deviceTest.vue"
import deviceAttributes from "@/components/device/deviceAttributes.vue"
import deviceLog from "@/components/device/deviceLog.vue"
import deviceReport from "@/components/device/deviceReport.vue"
import tPageUser from "@/components/tPageUser.vue"

import eventBus from "@/plugins/eventBus.js"

export default {
  name: "tinkDevice",
  mixins: [uiUtil, user],
  props: {
    did: {
      type: String,
      default: ""
    },
    mode: {
      type: String,
      default: "intro"
    },
    action: {
      type: String,
      default: ""
    },
  },
  components: {
    deviceIntro,
    deviceConfig,
    deviceAuth,
    deviceSensors,
    deviceSerial,
    deviceTest,
    deviceAttributes,
    deviceLog,
    deviceReport,
    authCheck,
    tPageUser,
  },
  data: function() {
    return {

      pageDeviceBinded: null,
      pageUserBinded: null,

      pageBinded: false,
      pageBindFinished: false,
      pageTimer: null,
      togglePageDeviceActiveDisabled: false,
      toggleRealtimeDisabled: true,

      serial: "",

    }
  },
  created: function() {

  },
  mounted: function() {
    firebase.auth().onAuthStateChanged((user) => {
      if(firebase.auth().currentUser != null) {
        this.doBindPageDeviceOnce();
      }
    })
  },
  beforeUpdate: function() {

  },
  updated: function() {

  },
  beforeDestroy() {
    if(this.pageTimer) {
      window.clearTimeout(this.pageTimer)
      this.pageTimer = null
    }
  },
  methods: {

    getSerial: function() {
      if(typeof(this.pageDevice.acode) === "undefined") {
        this.makeToast("danger", "접속코드 조회 실패", "기기 정보에 접속코드가 없습니다.")
        return 
      }

      db.collection("acodes").doc(this.pageDevice.acode)
      .get()
      .then(acode => {
        if(acode.exists) {
          this.serial = acode.data().serial
        }
      })
      .catch(error => {
        this.makeToast("danger", "접속코드 조회 실패", "접속코드 조회 중에 에러가 발생했습니다. 에러 내용:" + error)
      })

      /*
      db.collection("acodes").where("device", "==", this.pageDevice.id).where("owner", "==", this.pageUser.id)
      .get()
      .then(acodeList => {
        acodeList.forEach(acode => {
          if(acode.exists) {
            this.serial = acode.data().serial
            this.acode = acode.id
          } 
        })
      })
      .catch(error => {
        this.makeToast("danger", "접속코드 조회 실패", "접속코드 조회 중에 에러가 발생했습니다. 에러 내용:" + error)
      })
      */
    },
    swipeApp: function(direction) {
      this.$log.debug("swife", direction);
      if(direction == "left") {
        eventBus.$emit("busUiShow", "myMenuShow");
        eventBus.$emit("busShowPageUser", false);
      }
      else if(direction == "right") {
        eventBus.$emit("busUiHide", "myMenuShow");
        eventBus.$emit("busShowPageUser", true);
      }
    },
    toggleRealtimeChanged: function() {
      if(this.pageBinded) {
        this.unbindPageDevice();
        this.toggleRealtimeDisabled = true;
        window.setTimeout(() => {
          this.toggleRealtimeDisabled = false;
        }, process.env.VUE_APP_CONTROL_DISABLED_TIMEOUT*1);
      }
      else {
        this.bindPageDevice();
      }
    },

    toggleActiveChanged: function() {
      if(this.pageDevice.active) {
        this.pageDevice.active = false;
        this.togglePageDeviceActiveDisabled = true;
        window.setTimeout(() => {
          this.togglePageDeviceActiveDisabled = false;
        }, process.env.VUE_APP_CONTROL_DISABLED_TIMEOUT*1);
      }
      else {
        this.pageDevice.active = true;
      }
      db.collection("devices").doc(this.pageDevice.id).update({
        active: this.pageDevice.active
      })
    },

    doBindPageDeviceOnce: function() {
      if(this.loginUserBinded) {
        this.bindPageDevice();
      }
      else {
        if(!this.notLoginConfirmed) {
          window.setTimeout(()=> {
            this.doBindPageDeviceOnce();
          },1000);
        }
      }
    },

    bindPageDevice: function() {
      // deepBinding을 사용하고 내 기기 인 경우
      if(this.loginUserDeepBinding && this.loginUser.devices[this.did]) {
        this.pageBinded = true;
        this.pageBindFinished = true;
        this.toggleRealtimeDisabled = true;
      }
      else {
        // deepBinding을 사용하고 내가 관리하는 기기인 경우
        let foundIndex = null;
        if(this.loginUserDeepBinding && this.adminDevices.some((device, index)=> {
          if(device.id == this.did) {
            foundIndex = index;
            return true;
          }
          return false;
        })) {
          this.$bind("pageUserBinded", db.collection("users").doc(this.adminDevices[foundIndex].owner), {
            maxRefDepth: 0,
            reset: false
          })
          .then(() => {
            this.pageBinded = true;
            this.pageBindFinished = true;
            this.toggleRealtimeDisabled = true;
            this.pageBindFinished = true;
          })
          .catch((error) => {
            console.log(error);
            this.pageBindFinished = true;
            this.toggleRealtimeDisabled = true;
          })
        }
        // deepBinding을 사용하지 않거나
        // 내 기기, 내가 관리하는 기기가 아닌 경우
        else {

          this.$bind("pageDeviceBinded", db.collection("devices").doc(this.did), {
            maxRefDepth: 1,
            reset: false
          })
          .then(() => {
            if(!this.loginUser.devices[this.did]) {
              this.$bind("pageUserBinded", db.collection("users").doc(this.pageDeviceBinded.owner), {
                maxRefDepth: 0,
                reset: false
              })
              .then(() => {
                this.pageBinded = true;
                this.pageBindFinished = true;
                this.toggleRealtimeDisabled = true;
                window.setTimeout(() => {
                  this.toggleRealtimeDisabled = false;
                }, process.env.VUE_APP_CONTROL_DISABLED_TIMEOUT*1);

                this.pageTimer = window.setTimeout(() => {
                  this.unbindPageDevice();
                }, process.env.VUE_APP_PAGE_TIMEOUT*1);
              })
              .catch((error) => {
                console.log(error);
                this.pageBindFinished = true;
                this.toggleRealtimeDisabled = true;
              })
            }
            else {
              this.pageBinded = true;
              this.pageBindFinished = true;
              this.toggleRealtimeDisabled = true;
              window.setTimeout(() => {
                this.toggleRealtimeDisabled = false;
              }, process.env.VUE_APP_CONTROL_DISABLED_TIMEOUT*1);
              this.pageTimer = window.setTimeout(() => {
                this.unbindPageDevice();
              }, process.env.VUE_APP_PAGE_TIMEOUT*1);
            }
          })
          .catch((error) => {
            console.log(error);
            this.pageBindFinished = true;
            this.toggleRealtimeDisabled = true;
          })
        }
      }
    },

    unbindPageDevice: function() {
      if(this.pageBinded) {
        if(this!= null) {
          if(this.pageDeviceBinded != null) this.$unbind("pageDeviceBinded", false);
          if(this.pageUserBinded != null) this.$unbind("pageUserBinded", false);
        }
        this.pageBinded = false;
        this.pageTimer = null;
      }
    },

  },
  computed: {
    pageDevice: function() {
      if(!this.pageBindFinished) {
        return null;
      }
      else if(this.pageDeviceBinded != null) {
        return this.pageDeviceBinded;
      }
      else if(this.loginUserDeepBinding && this.loginUser.devices[this.did]) {
        return this.loginUser.devices[this.did];
      }
      else {
        let foundIndex = null;
        if(this.loginUserDeepBinding && this.adminDevices.some((device, index)=> {
          if(device.id == this.did) {
            foundIndex = index;
            return true;
          }
          return false;
        })) {
          return this.adminDevices[foundIndex];
        }
      }
      return null;
    },

    pageUser: function() {
      if(!this.pageBindFinished) {
        return null;
      }
      else if(this.pageUserBinded != null) {
        return this.pageUserBinded;
      }
      else if(this.loginUser.devices[this.did]) {
        return this.loginUser;
      }
      return null;
    },
  },
  watch: {
    did: function() {

      if(this.pageTimer != null) {
        window.clearTimeout(this.pageTimer);
      }

      this.pageDeviceBinded = null;
      this.pageUserBinded = null;
      this.pageBinded = false;
      this.pageBindFinished = false;
      this.pageTimer = null;
      this.togglePageDeviceActiveDisabled = false;
      this.toggleRealtimeDisabled = true;

      window.setTimeout(() => {
        this.doBindPageDeviceOnce();
      }, 100);
    },
  },
}
</script>